import { createReducer } from '@reduxjs/toolkit';
import { CategoryShape, ALL_CATEGORIES_ID } from './model';
import * as categoryActions from './actions';
import * as appActions from '../app/actions';
import * as lastStateActions from '../lastState/actions';

const initial: CategoryShape = {
  categories: [],
  selectedId: ALL_CATEGORIES_ID,
  expandedKeys: [ALL_CATEGORIES_ID],
  loading: false,
};

export const categoryReducer = createReducer<CategoryShape>(initial, (builder) =>
  builder
    .addCase(categoryActions.categoriesChanged, (s, a) => {
      s.categories = a.payload.categories;
    })
    .addCase(categoryActions.categorySelected, (s, a) => {
      s.selectedId = a.payload.id;
    })
    .addCase(appActions.resetFilters, (s) => {
      s.selectedId = ALL_CATEGORIES_ID;
      s.expandedKeys = [ALL_CATEGORIES_ID];
    })
    .addCase(categoryActions.setExpandedKeys, (s, a) => {
      s.expandedKeys = a.payload.keys;
    })
    .addCase(categoryActions.setLoading, (s, a) => {
      s.loading = a.payload.loading;
    })
    .addCase(lastStateActions.applied, (s, a) => {
      if (a.payload) {
        s.selectedId = a.payload.state.data.category.selectedId;
        s.expandedKeys = a.payload.state.data.category.expandedKeys;
      } else {
        s.selectedId = initial.selectedId;
        s.expandedKeys = initial.expandedKeys;
      }
    }),
);
